import { CatalogItemDetailsPanelStyled } from './styles/CatalogItemDetailsPanelStyled'
import { CatalogItemDetails } from '../../../../components/CatalogItemDetails'
import { type ICatalogItemTagProps } from '../../../../components/CatalogItemTag'
import {
  CatalogItemTagIcons,
  CatalogItemTagVariants,
} from '../../../../value-objects/CatalogItemTag'
import {
  type ConversationCatalogItemComponent,
  type ConversationCatalogItemTag,
} from '../../../../value-objects/ConversationTurnItem'

export interface ICatalogItemDetailsPanelProps {
  item: ConversationCatalogItemComponent
  quantity: number
  estimatedTotal: number
  onQuantityChange: (quantity: number) => void
  onAddToRequest: () => void
  onChipSelect: (message: string) => void
  onCollapse: () => void
}

const resolveSourceTag = (
  tags: ConversationCatalogItemTag[]
): ICatalogItemTagProps =>
  tags.find((tag) => tag.variant !== CatalogItemTagVariants.WARNING) ??
  tags[0] ?? { icon: CatalogItemTagIcons.CATALOG, text: '' }

export const CatalogItemDetailsPanel = ({
  item,
  quantity,
  estimatedTotal,
  onQuantityChange,
  onAddToRequest,
  onChipSelect,
  onCollapse,
}: ICatalogItemDetailsPanelProps) => (
  <CatalogItemDetailsPanelStyled>
    <CatalogItemDetails
      key={item.itemId}
      img={item.img}
      images={item.images}
      title={item.title}
      sku={item.sku}
      tag={resolveSourceTag(item.tags)}
      price={item.price}
      currency={item.currency}
      vendor={item.vendor}
      rating={item.rating}
      vendorBadges={item.vendorBadges}
      listPrice={item.listPrice}
      volumePricing={item.volumePricing}
      sections={item.detailSections}
      delivery={item.delivery}
      quantity={quantity}
      estimatedTotal={estimatedTotal}
      onQuantityChange={onQuantityChange}
      onAddToRequest={onAddToRequest}
      onChipSelect={onChipSelect}
      onCollapse={onCollapse}
    />
  </CatalogItemDetailsPanelStyled>
)
